if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.butItNow = this.querySelector('.product_go_checkout');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        if (this.butItNow) {
          this.butItNow.addEventListener('click', function(){
            if (typeof getCookiesByKeyPart === 'function') {
              let alyValue = sessionStorage.getItem('discount_code')
              if (alyValue) {
                setCookiesKey('discount_code', alyValue)
              } else {
                let disCode = getCookiesByKeyPart('ecomsend_discount_code', true)
                if (disCode) setCookiesKey('discount_code', disCode)
              }
            }
            window.location.href = '/cart/' + $('.product-variant-id').val() + ':1';
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const is_desks_form = $(evt.target).hasClass('desks_form');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        // let disAddCode = getCookiesByKeyPart('discount_code', true) || sessionStorage.getItem('discount_code')
        let subAddToCard = (is_show_drawer) => {
          let formData = new FormData(this.form);
          let formDataId = undefined;
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
            formDataId = formData.get('id')
          }
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formDataId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formDataId,
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response, is_show_drawer);
              }
              if (typeof setFooterCart !== "undefined" && !is_show_drawer) setFooterCart()
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        }
        let elementEl = $('.product_bundle_item.active')
        if ($('.product_bundle_item.active').length > 0){
          let moreFormData = {items: []}
          for(let i = 0; i < elementEl.length; i++){
            moreFormData.items.push({id: Number(elementEl.eq(i).find('.bundle_price_section').attr('data-variant-id')), quantity: 1})
          }
          let moreConfig = fetchConfig('javascript');
          moreConfig.body = JSON.stringify(moreFormData)
          fetch(`${routes.cart_add_url}`, moreConfig).then(response => {
            subAddToCard(true)
          })
        } else {
          subAddToCard(!!$('.accessories_list .accessories_item').length)
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
